import React from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  value?: string;
  description?: string;
}

export const EstateStatusItem = ({
  value,
  description,
}: Props): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        m: 4,
      }}
    >
      <Typography variant="h3" sx={{ color: "inherit" }}>
        {value}
      </Typography>
      <Typography variant="body2" sx={{ color: "inherit" }}>
        {description}
      </Typography>
    </Box>
  );
};
